;(function () {
  angular
    .module('contrast.filters')
    .filter('adjustTimezone', function (TimeService, DEFAULT_DATETIME_FORMAT) {
      return function (value, format) {
        if (!value) {
          return ''
        }
        format = format || DEFAULT_DATETIME_FORMAT

        format = moment().toMomentFormatString(format)

        return moment(value)
          .add(TimeService.getOffsetDifference(), 'm')
          .format(format)
      }
    })
})()
